import { useRef, useState } from 'react';

const LIMIT = 100;

// Bounded, per-editor-instance undo/redo over the objects array. Consecutive commits sharing a
// coalesce key (e.g. typing in one text box, dragging one slider) merge into a single entry.
export function useWhiteboardHistory(objects, apply) {
  const h = useRef({ past: [], future: [], lastKey: null });
  const [, bump] = useState(0);

  const commit = (next, key = null) => {
    const s = h.current;
    if (!(key && key === s.lastKey)) {
      s.past = [...s.past, objects].slice(-LIMIT);
    }
    s.future = [];
    s.lastKey = key;
    apply(next);
    bump((n) => n + 1);
  };
  const step = (from, to) => {
    const s = h.current;
    if (!s[from].length) return false;
    const prev = s[from][s[from].length - 1];
    s[from] = s[from].slice(0, -1);
    s[to] = [...s[to], objects].slice(-LIMIT);
    s.lastKey = null;
    apply(prev);
    bump((n) => n + 1);
    return true;
  };
  return {
    commit,
    undo: () => step('past', 'future'),
    redo: () => step('future', 'past'),
    canUndo: h.current.past.length > 0,
    canRedo: h.current.future.length > 0,
  };
}
